import { SettingsRoutes } from '../router.types';

export const settingsRoutes: SettingsRoutes = {
  settingsProfile: '/settings/profile',
  settingsNotificationsPreferences: '/settings/notifications-preferences',
  settingsAgency: '/agency/settings',
};
